/* global window */

var lodash

if (typeof require === 'function') {
  try {
    lodash = require('lodash')
  } catch (e) {}
}

if (!lodash) {
  lodash = window._
}

module.exports = lodash
